import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class PaymentApi {
    constructor(private axios: AxiosInstance) {
    }

    init = async (): Promise<{
        price: number,
        percent: string,
        url: string
    }> => {
        const {data} = await this.axios
            .withAuthentication()
            .withLanguage()
            .post('/v1/init-payment');

        return data as {
            price: number,
            percent: string,
            url: string
        };
    };
}

decorate(injectable(), PaymentApi);
decorate(inject(AxiosInstance), PaymentApi, 0);

export {PaymentApi};
